import { Link } from 'react-router-dom'
import { EtiquetaDeStatus } from '../../components/Etiqueta'
import { TEXTOS } from '../../lib/glossario'
import type { StatusGmud } from '../../types/gmud'
import type { SolicitacaoCitada } from '../../types/repositorios'

/**
 * As solicitações de mudança citadas nos commits do mês, com o estado de cada uma hoje.
 *
 * O estado é o dado que importa: uma solicitação ainda não aprovada com commits na branch
 * principal é código integrado antes da decisão do comitê. A etiqueta é a mesma da lista de
 * solicitações, para o estado ser lido do mesmo jeito nas duas telas.
 *
 * @param props as solicitações
 * @returns a lista, ou nada quando nenhuma foi citada
 */
export function SolicitacoesCitadas({ solicitacoes }: { solicitacoes: SolicitacaoCitada[] }) {
  const t = TEXTOS.repositorios
  if (solicitacoes.length === 0) {
    return null
  }
  return (
    <section className="cartao p-4" aria-label={t.secoes.solicitacoes}>
      <h2 className="text-base font-semibold text-slate-900">{t.secoes.solicitacoes}</h2>
      <ul className="mt-3 flex flex-wrap gap-2">
        {solicitacoes.map((s) => (
          <li key={s.gmudId} className="flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-1.5 text-sm">
            <Link to={`/gmuds/${s.gmudId}`} className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900">
              {s.codigo}
            </Link>
            <EtiquetaDeStatus status={s.status as StatusGmud} />
            <span className="tabular-nums text-slate-500">
              {s.commits} {s.commits === 1 ? 'commit' : 'commits'}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
